<template>
  <img :src="currentImage || fallback" :alt="alt" @error="onImageError" />
</template>

<script setup>
import { computed } from 'vue'
import { freshAdminImage } from '@/utils/adminFreshness'
import { productImageUrls, useImageGallery } from '@/composables/useProductImages'

const props = defineProps({
  product: { type: Object, default: null },
  sources: { type: Array, default: null },
  alt: { type: String, default: '' },
  preferSecondary: { type: Boolean, default: false },
  fallback: { type: String, default: '/LOGO.svg' },
})
const sourceImages = computed(() => props.sources
  ? [...new Set(props.sources.filter(url => typeof url === 'string' && url.trim())
    .map(url => freshAdminImage(url, props.product)))]
  : productImageUrls(props.product, props.preferSecondary))
const { currentImage, onImageError } = useImageGallery(sourceImages)
</script>
